import { type IBucket, IBucketID } from '@bridebook/models/source/models/Countries/Buckets.types';
import { PremiumTiers } from '@bridebook/toolbox/src/constants';

const result: IBucket = {
  id: IBucketID.LITE,
  settings: {
    automaticDowngradeToUnverified: null,
    autoFollowUpTemplatedResponses: null,
    weddingFairs: null,
    templatedResponses: null,
    instagramIntegration: null,
    realWeddings: null,
    realWeddingsCarousel: null,
    trendingCarousel: null,
    trendingCarouselSuppliers: null,
    roiSummary: null,
    badges: null,
    topSpot: null,
    multiCounty: null,
    venueTypeHero: null,
    couplesIntel: null,
    lostLeadsStats: null,
    lostLeadTracking: null,
    yourCompetitors: null,
    couplesActivity: null,
    revealCoupleEmailAddress: null,
    revealCouplePhoneNumber: null,
    lostLeadsInsightsEnquirySource: null,
    contactCouples: null,
    coupleTargeting: null,
    coupleTargetingGuestCount: null,
    lateAvailability: null,
    couplesInsightsSearchAppearances: null,
    couplesInsightsProfileViews: null,
    couplesInsightsEnquiries: null,
    deals: null,
    searchOptimisation: null,
    bridebookDiscounts: null,
    videoTours: null,
    professionalNetwork: null,
    specialOfferRecommendation: null,
    searchPerformance: null,
    socialMediaSupport: null,
    marketInsightsStats: null,
    marketInsightsStatsCoupleBudget: null,
    bridebookInstitute: null,
    upgradePlan: null,
    weddingReports: null,
    searchBoost: null,
    adminBanners: null,
    businessSelfSignUp: null,
    featureTutorials: null,
    aboutYou: null,
    countyDropdown: null,
    searchPresets: null,
    smartEmails: null,
    enquiryWidget: null,
    onboardingConciergeFlow: null,
    locations: null,
    trends: null,
    historicalSearchPositionChart: null,
    keepRelationsOnTierDowngrade: null,
    replyToReviews: null,
    inspirationAndAdvice: null,
    specialOffersCarousel: null,
    rapidResponder: null,
    featuredSupplierMarker: null,
    youMayAlsoLikeCarousel: null,
    couplesAlsoLikeCarousel: null,
    additionalImageOnSearch: null,
    quickFilters: null,
    recommendedSuppliersCarousel: null,
    recommendations: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['venue'],
      },
    },
  },
};

export default {
  [result.id]: result,
};
